import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PrimaryButton } from '../../../Button/button.styled';

const StyledButton = styled(PrimaryButton)`
  height: 2.5rem;
  min-width: auto;
  text-decoration: bold;
  text-transform: capitalize;
  width: 100%;

  &:focus:enabled {
    box-shadow: none;
    outline: none;
  }
`;

function StudioSelectorButton({ isOpen, onClick, ...rest }) {
  const handleClick = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <StyledButton
      id="mobile-studio-selector-button"
      onClick={handleClick}
      {...rest}
    >
      {isOpen ? 'close' : 'book a bike'}
    </StyledButton>
  );
}

StudioSelectorButton.displayName = 'StudioSelectorButton';

StudioSelectorButton.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
};

StudioSelectorButton.defaultProps = {
  isOpen: false,
  onClick: () => {},
};

export default StudioSelectorButton;
